module.exports = __webpack_public_path__ + "static/media/expo1.49c33b91.webp";